import { create } from 'zustand'

interface IgnoreTxNotificationsState {
    ids: Set<string>
    startIgnoreId: (txId: string) => void
    stopIgnoreId: (txId: string) => void
}

export const useIgnoreTxNotificationsStore = create<IgnoreTxNotificationsState>(set => ({
    ids: new Set(),
    startIgnoreId: (txId: string) => {
        set(prev => {
            const newCollection = new Set(prev.ids)
            newCollection.add(txId)
            return { ids: newCollection }
        })
    },
    stopIgnoreId: (txId: string) => {
        set(prev => {
            const newCollection = new Set(prev.ids)
            newCollection.delete(txId)
            return { ids: newCollection }
        })
    },
}))
